import httpClient from '../../api';
import {
  fetchInitSingle,
  fetchSingle,
  fetchInitCollection,
  fetchCollection,
} from '../store-common';

export default () => ({
  namespaced: true,

  state: () => ({
    company: fetchInitSingle(),
    vacancies: fetchInitCollection(),
  }),

  mutations: {
    setCompany(state, payload) {
      state.company = { ...payload };
    },
    setVacancies(state, payload) {
      state.vacancies = { ...payload };
    },
  },

  actions: {
    async fetchCompany(context, id) {
      context.commit('setVacancies', fetchInitCollection());
      await fetchSingle(async () => {
        const { data: { data } } = await httpClient.get(`/companies/${id}`);
        return data;
      }, context, 'setCompany');
    },
    async fetchCompanyById(context, id) {
      const { data: { data } } = await httpClient.get(`/companies/${id}`);
      return data;
    },
    async fetchVacancies(context, companyId) {
      await fetchCollection(async () => {
        const { data: { data } } = await httpClient.get(`/companies/${companyId}/active-vacancies`);
        return data;
      }, context, 'setVacancies');
    },
    async register(context, payload) {
      return httpClient.post('companies', payload);
    },
  },
});
